import Header from "../components/Header";
import { Page } from "../components/_partials";

function Contact() {
  return (
    <Page>
      <Header />
      <h1>Contact</h1>
      <p>
        Portfolio en construction, merci pour votre compréhension
      </p>
      <a href="mailto:kervadecmatteo@gmail.com">Envoyer un email</a>
    </Page>
  );
}

export default Contact;
